module.exports = __webpack_public_path__ + "static/media/CTExcel-CorporatelVideo-2017_Eng&Chi11111.8c88fed.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/images/CTExcel-CorporatelVideo-2017_Eng&Chi11111.mp4
// module id = hyBd
// module chunks = 1